// this file was prevaled
module.exports={"name":"mangane-fe","displayName":"Mangane","url":"https://github.com/BDX-town/Mangane","repository":"BDX-town/Mangane","version":"wrestling-red-panda-0a31c4e","homepage":"https://bdx.town"};